import { render, staticRenderFns } from "./PtoFileSidebar.vue?vue&type=template&id=c2ef4fec&"
import script from "./PtoFileSidebar.vue?vue&type=script&lang=js&"
export * from "./PtoFileSidebar.vue?vue&type=script&lang=js&"
import style0 from "./PtoFileSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports